import React, { Fragment, memo, useState, useEffect } from 'react';
import config from 'Config';
import { AbTasty } from './AbTasty';
import { ContentSquare } from './ContentSquare';
import { Hosting } from './Hosting';
import { Udesk } from './Udesk';
import { Cedexis } from './Cedexis';
import { Sentry } from './Sentry';
const DELAY_LOAD = config.get('thirdParty.delayLoad') ?? false;
const DELAY_TIMER = config.get('thirdParty.timer') ?? 5000;
const LOAD_OPTIONS = {
  once: true,
  passive: true,
};
export const ThirdPartyScripts = memo<{}>(() => {
  const [delaying, setDelaying] = useState(DELAY_LOAD);
  useEffect(() => {
    if (!DELAY_LOAD || typeof window === 'undefined') {
      return;
    }

    const timeoutHandler = () => {
      setDelaying(false);
    };

    let timeout = null;

    const loadHandler = () => {
      timeout = setTimeout(timeoutHandler, DELAY_TIMER);
    };

    window.addEventListener('load', loadHandler, LOAD_OPTIONS);
    return () => {
      window.removeEventListener('load', loadHandler, LOAD_OPTIONS);
      clearTimeout(timeout);
    };
  }, []);

  if (delaying) {
    return null;
  }

  return (
    <Fragment>
      <Udesk />
      <ContentSquare />
      <Hosting />
      <AbTasty />
      <Cedexis />
      <Sentry />
    </Fragment>
  );
});
